// extracted by mini-css-extract-plugin
module.exports = {"pills":"filterPills_pills__GHOkt","pillsContainer":"filterPills_pillsContainer__TGjD1","icon":"filterPills_icon__DJB4k"};